import React, { useContext, useState, Fragment, useRef } from 'react';
import { withStyles, Divider } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';
import LeftTail from '../../../asset/img/bubble_point1.png';
import Arrow from '../../../asset/img/ic_list_arrow_nor.svg';

import ReservePlace from '../../modal/ReservePlace';
import ReserveInstall from '../../modal/ReserveInstall';
import ReserveFan from '../../modal/ReserveFan';
import Reserve from '../../modal/Reserve';
import ValidatePhone from '../../modal/ValidatePhone';
import SearchByReserveNum from '../../modal/SearchByReserveNum';
import Counsel from '../../modal/Counsel';
import ReserveCall from '../../modal/ReserveCall';

import { useToasts } from 'react-toast-notifications';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 16px',
    margin: '0 0 12px 0',
  },
  message: {
    width: '100%',
    fontSize: theme.font.size14, // "15px",
    borderRadius: '10px',
    flexWrap: 'wrap',
    backgroundColor: theme.color.message.background,
    color: theme.color.message.color,
    wordWrap: 'break-word',
    margin: '0 0 6px 0',
    padding: '12px 16px',
  },
  list: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  itemOnlyOne: {
    borderRadius: '6px',
  },
  itemFirst: {
    borderRadius: '6px 6px 0 0',
  },
  itemLast: {
    borderRadius: '0 0 6px 6px',
  },
  item: {
    minHeight: '2.5rem',
    textAlign: 'center',
    color: theme.color.accent,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0px',
    margin: '0px',
    backgroundColor: theme.color.button.background_white,
    textTransform: 'none',
    // outline: '0 none',
    border: 'none',
    borderRight: '1px solid #ddd',
    borderLeft: '1px solid #ddd',
    // borderBottom: "1px solid  #eee",
    borderBottom: '1px solid  #ddd',
    '&:first-child': {
      // borderRadius:"6px 6px 0px 0px",
      borderTop: '1px solid #ddd',
    },
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
    cursor: 'pointer',
  },
  vertical: {
    height: 'auto',
  },
  leftTail: {
    // borderLeft: '14px solid transparent',
    // borderRight: '14px solid transparent',
    // borderTop: '18px solid #fff',
    // borderRadius: '5px',
    zIndex: 11,
    margin: '6px -21px 0px 11px',
    backgroundImage: `url(${LeftTail})`,
    backgroundSize: '21px 12px',
    width: '21px',
    height: '12px',
    minWidth: '21px',
  },
  buttonText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '2.5rem',
    color: '#262626',
    padding: '0px 20px',
    // fontSize: theme.font.size14,
    textAlign: 'start',
  },
  arrow: {
    width: '1.8em',
    height: '1.8em',
    backgroundSize: 'contain',
    background: `url(${Arrow}) no-repeat right center`,
    padding: '.5em',
  },
});

function TL(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
  const fanLocationInstallTypeList = ['V', 'R', 'I', 'O', 'E', 'F', 'T'];
  const [fanLocationInstallType, setFanLocationInstallType] = useState('');
  const contactRating = '';
  const [reserveData, setReserveData] = useState(null);
  const [linkData, setLinkData] = useState(null);
  const [modalStatus, setModalStatus] = useState('');
  const [modalOpen, setModalOpen] = useState({
    place: false,
    installType: false,
    fanLocation: false,
    reserve: false,
  });
  const modalValueInitial = {
    place: null,
    installType: null,
    fanLocation: null,
    reserve: null,
  };
  const [modalValue, setModalValue] = useState(modalValueInitial);

  const [openValidatePhone, setOpenValidatePhone] = useState(false);
  const [validatePhoneData, setValidatePhoneData] = useState(null);

  const [openSearchByReserveNum, setOpenSearchByReserveNum] = useState(false);
  const [searchByReserveNumData, setSearchByReserveNumData] = useState(null);

  const [openCounsel, setOpenCounsel] = useState(false);
  const [counselData, setCounselData] = useState(null);
  const [counselTitle, setCounselTitle] = useState('');

  const [openReserveCall, setOpenReserveCall] = useState(false);
  const [reserveCallData, setReserveCallData] = useState(null);

  const updateModalValue = (targetModalStatus, newModalValue) => {
    setModalValue((prev) => {
      return {
        ...prev,
        [targetModalStatus]: newModalValue,
      };
    });
  };

  const getPrevModal = (buttonData) => {
    const reserveDataTemp = buttonData.data;

    console.log('modalStatus ::::::', modalStatus);
    console.log(
      'reserveDataTemp?.need_place_type ::::::',
      reserveDataTemp?.need_place_type
    );

    if (modalStatus === 'reserve') {
      if (reserveDataTemp?.need_fan_location) {
        return 'fanLocation';
      } else if (reserveDataTemp?.need_install_type) {
        return 'installType';
      } else if (reserveDataTemp?.need_place_type) {
        return 'place';
      }
      return '';
    } else if (modalStatus === 'fanLocation') {
      if (reserveDataTemp?.need_install_type) {
        return 'installType';
      } else if (reserveDataTemp?.need_place_type) {
        return 'place';
      }
      return '';
    } else if (modalStatus === 'installType') {
      if (reserveDataTemp?.need_place_type) {
        return 'place';
      }
      return '';
    } else {
      return '';
    }
  };
  const getNextModal = (buttonData) => {
    const reserveDataTemp = buttonData.data;
    console.log('reserveDataTemp :::::', reserveDataTemp);
    console.log('modalStatus :::::', modalStatus);

    if (!modalStatus) {
      if (reserveDataTemp?.need_place_type) {
        return 'place';
      } else if (reserveDataTemp?.need_install_type) {
        return 'installType';
      } else if (reserveDataTemp?.need_fan_location) {
        return 'fanLocation';
      } else {
        return 'reserve';
      }
    } else if (modalStatus === 'place') {
      if (reserveDataTemp?.need_install_type) {
        return 'installType';
      } else if (reserveDataTemp?.need_fan_location) {
        return 'fanLocation';
      } else {
        return 'reserve';
      }
    } else if (modalStatus === 'installType') {
      if (reserveDataTemp?.need_fan_location) {
        return 'fanLocation';
      } else {
        return 'reserve';
      }
    } else if (modalStatus === 'fanLocation') {
      return 'reserve';
    } else if (modalStatus === 'reserve') {
      return '';
    }
  };

  const closeModal = (modalStatus) => {
    setModalOpen((prev) => {
      return {
        ...prev,
        [modalStatus]: false,
      };
    });
  };

  const openModal = (nextStatus) => {
    setModalOpen((prev) => {
      let newObj = {
        ...prev,
        [nextStatus]: true,
      };
      if (modalStatus) {
        newObj[modalStatus] = false;
      }
      return newObj;
    });
    setModalStatus(nextStatus);
  };
  const openNextModal = (nextStatus) => {
    if (nextStatus) {
      openModal(nextStatus);
    }
  };

  const openPrevModal = (prevStatus) => {
    if (prevStatus) {
      openModal(prevStatus);
    } else {
      console.log('No prev modal exists');
    }
  };

  const closeOrGoto = (goto, closeModalStatus) => {
    if (typeof goto !== 'string') {
      closeModal(closeModalStatus);
      setReserveData(null);
      setModalStatus('');
      setModalValue(modalValueInitial);
    } else if (goto === 'next') {
      let nextStatus = getNextModal(reserveData);

      console.log('nextStatus ::::::', nextStatus);
      if (nextStatus) {
        openNextModal(nextStatus);
      } else {
        console.log('The End - need to implement passing bypass to DM');
      }
    } else if (goto === 'prev') {
      let prevStatus = getPrevModal(reserveData);
      if (prevStatus) {
        openPrevModal(prevStatus);
      } else {
        console.log("Can't go to prev");
      }
    }
  };

  const parentFunc = {
    getPrevModal: () => getPrevModal(reserveData),
    getNextModal: () => getNextModal(reserveData),
  };

  const handleClick = (link) => {
    var type = link.type;
    var url = link.url;

    if (type.toLowerCase() === 'faq') {
      type = 'inapp';
      url = `${window.location.href}ext/faq/faq.html?url=${url}`;
    }
    if (type.toLowerCase() === 'modal') {
      const modalType = link.modal.type;
      if (modalType === 'engineer' || modalType === 'cleaning') {
        if (link.modal?.data?.need_inspection === true) {
          const defaultExpect = link?.expect;
          const defaultParameters = link?.parameters;
          const inspectionData = link.modal?.data?.inspection_data;
          context.request(
            context,
            defaultParameters?.speech || '',
            'button',
            {
              ...inspectionData,
              ...defaultParameters,
              bypass_br: 'inspection',
            },
            defaultExpect || {
              mode: 'bypass',
              intent: 'THQ_ENGINEER_BOOK_BYPASS',
            }
          );
        } else {
          setReserveData(link.modal);
          setLinkData(link);

          let nextStatus = getNextModal(link.modal);
          openNextModal(nextStatus);

          const rootChild = document.getElementById('root');
          const focusableElements = rootChild.querySelectorAll('*');

          for (let i = 0; i < focusableElements.length; i++) {
            focusableElements[i].setAttribute('aria-hidden', 'true');
          }
        }
      } else if (modalType === 'simple_login') {
        setValidatePhoneData(link);
        setOpenValidatePhone(true);

        const rootChild = document.getElementById('root');
        const focusableElements = rootChild.querySelectorAll('*');

        for (let i = 0; i < focusableElements.length; i++) {
          focusableElements[i].setAttribute('aria-hidden', 'true');
        }
      } else if (modalType === 'search_regist_num') {
        setSearchByReserveNumData(link);
        setOpenSearchByReserveNum(true);

        const rootChild = document.getElementById('root');
        const focusableElements = rootChild.querySelectorAll('*');

        for (let i = 0; i < focusableElements.length; i++) {
          focusableElements[i].setAttribute('aria-hidden', 'true');
        }
      } else if (modalType === 'counsel') {
        let modalTitle = '';
        let counselType = link.modal.data?.counsel_type;
        if (counselType === 'purchase') {
          modalTitle = '구매 전문가 상담';
        } else if (counselType === 'customer') {
          modalTitle = '고객 서비스 상담';
        } else if (counselType === 'delivery' || counselType === 'delivery_counsel') {
          modalTitle = '비회원 배송 문의';
        }

        setCounselData(link);
        setCounselTitle(modalTitle);
        setOpenCounsel(true);

        const rootChild = document.getElementById('root');
        const focusableElements = rootChild.querySelectorAll('*');

        for (let i = 0; i < focusableElements.length; i++) {
          focusableElements[i].setAttribute('aria-hidden', 'true');
        }
      } else if (modalType === 'call') {
        setOpenReserveCall(true);
        setReserveCallData(link);

        const rootChild = document.getElementById('root');
        const focusableElements = rootChild.querySelectorAll('*');

        for (let i = 0; i < focusableElements.length; i++) {
          focusableElements[i].setAttribute('aria-hidden', 'true');
        }
      }

      if (link.event_action) {
        context.log(context, 'clicks', link.event_action);
      }
    } else {
      openLink(context, type, url, link.event_action);
    }
  };

  return (
    <>
      <div className={[classes.root].join(' ')}>
        {data.text && (
          <div className={classes.message} tabIndex={0}>
            {data.text.split('\n').map((content, index) => (
              <Fragment key={index}>
                {content}
                <br />
              </Fragment>
            ))}
          </div>
        )}

        <Divider component={'div'} disabled />
        <div className={classes.list}>
          {data.link &&
            data.link.map((link, index) => (
              <Fragment key={`linkKey-${index}`}>
                {/* {index !== 0 && <Divider component={"div"} disabled />} */}
                <button
                  type="button"
                  className={[
                    data.link.length === 1
                      ? classes.itemOnlyOne
                      : index === 0
                      ? classes.itemFirst
                      : index === data.link.length - 1
                      ? classes.itemLast
                      : '',
                    classes.item,
                  ].join(' ')}
                  disabled={context.conversationEnd}
                  onClick={() => {
                    handleClick(link);
                    console.log('link :::: ', link);
                  }}
                  aria-label={`${
                    link.type.toLowerCase() === 'external'
                      ? context.string.aria.external + ','
                      : ''
                  } ${link.label}`}
                >
                  <div className={classes.buttonText}>
                    {link.label}
                    <div className={classes.arrow} />
                  </div>
                </button>
              </Fragment>
            ))}
        </div>
      </div>
      {modalOpen['place'] && (
        <ReservePlace
          curModalValue={modalValue['place']}
          updateModalValue={(value) => updateModalValue('place', value)}
          data={{ orgData: reserveData, linkData, modalValue }}
          modalOpen={modalOpen['place']}
          modalClose={(goto) => {
            console.log('goto:::: ', goto);

            closeOrGoto(goto, 'place');
          }}
        />
      )}
      {modalOpen['installType'] && (
        <ReserveInstall
          curModalValue={modalValue['installType']}
          updateModalValue={(value) => {
            updateModalValue('installType', value);
            console.log('세탁기 ReserveInstall ::::::', value);
          }}
          data={{ orgData: reserveData, linkData, modalValue }}
          modalOpen={modalOpen['installType']}
          modalClose={(goto) => {
            closeOrGoto(goto, 'installType');
          }}
          parentFunc={parentFunc}
        />
      )}
      {modalOpen['fanLocation'] && (
        <ReserveFan
          curModalValue={modalValue['fanLocation']}
          updateModalValue={(value) => updateModalValue('fanLocation', value)}
          // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
          updateFanLoacationValue={(value) => {
            updateModalValue('fanLoaction', fanLocationInstallTypeList[value]);
            setFanLocationInstallType(fanLocationInstallTypeList[value]);
            console.log(
              'fanLocationInstallTypeList ::::::',
              fanLocationInstallTypeList[value]
            );
          }}
          contactRating={contactRating} // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
          data={{ orgData: reserveData, linkData, modalValue }}
          modalOpen={modalOpen['fanLocation']}
          modalClose={(goto) => {
            closeOrGoto(goto, 'fanLocation');
          }}
          parentFunc={parentFunc}
        />
      )}
      {modalOpen['reserve'] && (
        <Reserve
          data={{
            orgData: reserveData,
            linkData,
            modalValue,
            fanLocationInstallType, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
            contactRating, // 폭염 T/T 산정을 위한 API변경 요청의 건 25-05
          }}
          modalOpen={modalOpen['reserve']}
          modalClose={(goto) => {
            closeOrGoto(goto, 'reserve');
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
        />
      )}

      {validatePhoneData && (
        <ValidatePhone
          data={validatePhoneData}
          modalOpen={openValidatePhone}
          modalClose={() => {
            setOpenValidatePhone(false);
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
        />
      )}
      {openSearchByReserveNum && (
        <SearchByReserveNum
          data={searchByReserveNumData}
          modalOpen={openSearchByReserveNum}
          modalClose={() => {
            setOpenSearchByReserveNum(false);
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
        />
      )}
      {openCounsel && (
        <Counsel
          data={counselData}
          modalOpen={openCounsel}
          modalClose={() => {
            setOpenCounsel(false);
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
          title={counselTitle}
        />
      )}
      {openReserveCall && (
        <ReserveCall
          data={reserveCallData}
          modalOpen={openReserveCall}
          modalClose={() => {
            setOpenReserveCall(false);
            const rootChild = document.getElementById('root');
            const focusableElements = rootChild.querySelectorAll('*');

            for (let i = 0; i < focusableElements.length; i++) {
              focusableElements[i].removeAttribute('aria-hidden');
            }
          }}
        />
      )}
    </>
  );
}
export default withStyles(styles)(TL);
